module.exports = __webpack_public_path__ + "img/rion-amilcar-scott.9532b076.png";